import HeaderAction from './HeaderAction';
interface LogoutProps {
  logout: () => void;
  [key: string]: any;
}

function Logout({ logout, ...other }: LogoutProps) {
  return (
    <HeaderAction
      id="sign-out-btn"
      iconName="arrow-right-from-bracket"
      label="Sign out"
      onClick={logout}
      {...other}
    />
  );
}

export default Logout;
